import React, { useEffect, useState } from "react";
import "../Styles/MapaSocietario.css";
import { db } from "../firebase";
import { collection, getDocs} from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { useNavigate, useParams } from "react-router-dom";

function useWindowSize() {
  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  React.useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
}

function MapaSocietario() {

    const navigate = useNavigate();
    const { hubId } = useParams();
    const [nodes, setNodes] = useState([]);
    const [relations, setRelations] = useState([]);

    const [miembros, setMiembros] = useState([]);
    const [miembroSeleccionado, setMiembroSeleccionado] = useState(null);

    const [radiusFactor, setRadiusFactor] = useState(0.7); // valor por defecto

    const { width, height } = useWindowSize();
    const centerX = width / 2;
    const centerY = height / 2;
    const radius = Math.min(width, height) * (radiusFactor / 2); // Ajusta el radio según el tamaño de la ventana


    useEffect(() => {
        const fetchMiembros = async () => {
            const snapshot = await getDocs(
            collection(db, "private-hubs", hubId, "Miembros")
            );
            const lista = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
            }));
            setMiembros(lista);
            if (lista.length > 0) {
            setMiembroSeleccionado(lista[0]);
            }
        };

        fetchMiembros();
    }, [hubId]);

    useEffect(() => {
        const fetchParticipaciones = async () => {
            if (!miembroSeleccionado) return;

            const participacionesSnapshot = await getDocs(
              collection(
                  db,
                  "private-hubs",
                  hubId,
                  "Miembros",
                  miembroSeleccionado.id,
                  "Empresas"
              )
            );

            const empresasRegistradas = await getDocs(
              collection(
                  db,
                  "private-hubs",
                  hubId,
                  "Empresas"
              )
            );

            const relaciones = [];
            let empresaIdCounter = 2;

            participacionesSnapshot.forEach(doc => {
            const data = doc.data();
            relaciones.push({
                from: 1,
                to: empresaIdCounter,
                partDirecta: data.partDirecta,
                partTotal: data.partTotal,
                label: data.Nombre || `Empresa ${empresaIdCounter}`,
                nombreFicha: getNombreFicha(data.Nombre, empresasRegistradas.docs),
            });
            empresaIdCounter++;
            });

            // Ordenar relaciones por nombre de empresa
            const relacionesOrdenadas = [...relaciones].sort((a, b) =>
              a.label.localeCompare(b.label)
            );

            // Generar nodos ordenados
            const nodes = [
              { id: 1, label: miembroSeleccionado.Nombre || "Centro" },
              ...relacionesOrdenadas.map((rel, index) => ({
                id: index + 2, // mantener id consistentes a partir de 2
                label: rel.label,
                nombreFicha: rel.nombreFicha,
              }))
            ];

            // Reasignar relaciones con IDs consistentes
            const relacionesReasignadas = relacionesOrdenadas.map((rel, index) => ({
              ...rel,
              to: index + 2,
            }));

            setNodes(nodes);
            setRelations(relacionesReasignadas);
        };

        fetchParticipaciones();
    }, [miembroSeleccionado, hubId]);



    const angleStep = (2 * Math.PI) / Math.max(1, nodes.length - 1);

    const positions = nodes.map((node, i) => {
      let x = centerX;
      let y = centerY;
      if (i !== 0) {
        x = centerX + radius * Math.cos((i - 1) * angleStep);
        y = centerY + radius * Math.sin((i - 1) * angleStep);
      }
      return { ...node, x, y };
    });

    const getNodeById = (id) => positions.find((node) => node.id === id);

    const getNombreFicha = (nombre, empresasRegistradas) => {
      const nombreFicha = empresasRegistradas.find((doc) => {
        const data = doc.data();
        if (data.Nombre === nombre) {
          return true;
        }
        return false;
      });
      return nombreFicha.data().nombreFicha;
    };

    const handleEmpresaClick = async (label) => {
      try {
        const storage = getStorage();
        const fileRef = ref(storage, `${hubId}/${label}.docx`);
        const url = await getDownloadURL(fileRef);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${label}.docx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error descargando el archivo:", error);
        alert("No se pudo descargar el archivo. Verifica que exista en Storage.");
      }
    };

    return (
      <div style={{ width: "100vw", height: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#F9FAFB" }}>

        {/* Header */}
        <div className="page-header">
          <div className="page-title">Mapa Societario</div>
          <button className="back-button" onClick={() => navigate(-1)}>
            Volver al Lobby
          </button>
        </div>

        {/* Controles: selector + zoom */}
        <div style={{ padding: "16px 24px", display: "flex", flexDirection: "column", gap: "12px", backgroundColor: "#ffffff", zIndex: 1 }}>
          <div>
            <label style={{ marginRight: "10px", color: "#1E3A8A", fontWeight: "bold" }}>Selecciona un miembro:</label>
            <select
              className="custom-select"
              value={miembroSeleccionado?.id || ""}
              onChange={(e) => {
                const seleccionado = miembros.find(m => m.id === e.target.value);
                setMiembroSeleccionado(seleccionado);
              }}
            >
              <option value="">-- Selecciona --</option>
              {miembros.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.Nombre || m.id}
                </option>
              ))}
            </select>
          </div>

          <div className="zoom-container">
            <label>Zoom:</label>
            <input
              type="range"
              min="0.3"
              max="0.7"
              step="0.01"
              value={radiusFactor}
              onChange={(e) => setRadiusFactor(parseFloat(e.target.value))}
              className="custom-slider"
            />
          </div>
        </div>

        {/* SVG para flechas */}
        <svg
          style={{ position: "absolute", top: 0, left: 0, zIndex: 0}}
          width={width}
          height={height}
        >
          <defs>
            <marker
              id="arrowhead"
              markerWidth="10"
              markerHeight="7"
              refX="10"
              refY="3.5"
              orient="auto"
              fill="#1E3A8A"
            >
              <polygon points="0 0, 10 3.5, 0 7" />
            </marker>
          </defs>
          {relations.map((rel, i) => {
            const from = getNodeById(rel.from);
            const to = getNodeById(rel.to);
            return (
              <line
                key={i}
                x1={from?.x}
                y1={from?.y}
                x2={to?.x}
                y2={to?.y}
                stroke="#1E3A8A"
                strokeWidth="2"
                markerEnd="url(#arrowhead)"
              />
            );
          })}
        </svg>

        {/* Botones para nodos */}
        {positions.map((node) => (
          <button
            key={node.id}
            onClick={() => {
              if (node.id !== 1) {
                handleEmpresaClick(node.nombreFicha);
              }
            }}
            className="radial-button"
            style={{
              left: node.x - 50,
              top: node.y - 25,
              backgroundColor: node.id === 1 ? "#0F766E" : "#1E3A8A", // color distinto para nodo central
            }}
          >
            {node.label}
          </button>
        ))}

          {/* Cajas de datos para las relaciones */}
          {relations.map((rel, i) => {
          const from = getNodeById(rel.from);
          const to = getNodeById(rel.to);
          const midX = (from.x + to.x) / 2;
          const midY = (from.y + to.y) / 2;

          return (
              <div
              key={`info-${i}`}
              style={{
                  position: "absolute",
                  left: midX - 40,
                  top: midY - 25,
                  backgroundColor: "#E0F2FE",
                  border: "1px solid #0284C7",
                  borderRadius: 6,
                  padding: "4px 8px",
                  fontSize: "12px",
                  zIndex: 2,
                  textAlign: "center",
                  boxShadow: "0 1px 5px rgba(0,0,0,0.1)"
              }}
              >
              
              <div>D: {rel.partDirecta ?? "-"}</div>
              <div><strong>T: {rel.partTotal ?? "-"}</strong></div>
              
              </div>
          );
          })}

      </div>
    );
}

export default MapaSocietario;
